import { render, staticRenderFns } from "./siteHeader.vue?vue&type=template&id=8f4a11d2"
import script from "./siteHeader.vue?vue&type=script&lang=js"
export * from "./siteHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports